
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"14","height":"14"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.825 7l2.504-2.504a.583.583 0 10-.825-.825L7 6.175 4.496 3.671a.583.583 0 10-.825.825L6.175 7 3.671 9.504a.583.583 0 10.825.825L7 7.825l2.504 2.504a.581.581 0 00.825 0 .583.583 0 000-.825L7.825 7z","fill":"#6F8789"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#8492A6","d":"M0 0h14v14H0z"}})])])
          )
        }
      }
    